// src/colors.js

const colors = {
    primary: '#ff9900',        // Base color
    primaryDark: '#e68a00',    // Slightly darker tone
    primaryDarker: '#cc7a00',  // Even darker
    background: '#ff9900',     // Base background color
    textLight: '#ffffff',      // Light text color
    textDark: '#333333',       // Dark text color
};

export default colors;